module.exports = __webpack_public_path__ + "static/media/value_proposition_mobile.4bbd5dea.svg";